/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteGenreTitleRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable />} value={option.uuid} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_GENRE_TITLE_RELATION">
      <SelectionSet
        name="deleteGenre_title"
        alias="deleteGenreTitleRelation"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteGenreTitleRelation: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.genre.request<Data>(query, variables);
};
